


























































































































import { Component, Mixins } from 'vue-property-decorator'
import LeadDetails from './LeadDetails.vue'
import GlobalMixin from '@/mixins/GlobalMixin'
import LeadActions from './LeadActions.vue'
import {
  ICustomerLeadLightModel, PubPictureInfo, mval as val,
  $newObj, CustomerLeadFeedbackModel, LeadFeedbackStatus
} from '@immosparrow/cockpit-api-v2'
import moment from 'moment'

@Component({
  components: {
    LeadDetails,
    LeadActions
  }
})
export default class LeadItemFull extends Mixins(GlobalMixin) {
  val: Function = val

  get multipleLeads (): ICustomerLeadLightModel[] {
    return this.$store.getters.multipleLeads
  }

  get index () {
    return this.$store.getters.multipleLeadsIndex
  }

  set index (val: number) {
    this.$store.commit('setMultipleLeadsIndex', val)
  }

  get lead (): ICustomerLeadLightModel {
    return this.$store.getters.lead || this.multipleLeads[this.index]
  }

  get mailInfo () {
    return this.$store.getters.mailInfo
  }

  get description () {
    return this.lead?.publication?.primaryInfo?.basicInfo?.description || ''
  }

  get title (): string {
    return this.lead?.publication?.primaryInfo?.basicInfo?.title || ''
  }

  get currency () {
    return this.lead?.publication?.financialInfo?.currency?.text || 'CHF'
  }

  get price () {
    return this.formatPrice(this.lead?.publication?.financialInfo?.totalPriceCalculated)
  }

  get priceSqr () {
    return this.formatPrice(this.lead?.publication?.financialInfo?.pricePerSqrMeterCalculated)
  }

  get address () {
    return this.displayAddress(this.lead?.publication?.address)
  }

  get pictures () {
    return this.lead?.publication?.pictures?.map((item: PubPictureInfo) => {
      return this.generateImageUrl(item.id)
    }) || []
  }

  get fullScreenPictures () {
    return this.lead?.publication?.pictures?.map((item: PubPictureInfo) => {
      return this.generateImageUrl(item.id, window.innerWidth, window.innerHeight)
    })
  }

  get date () {
    if (this.mailInfo?.length) {
      return moment.utc(this.mailInfo[0].sentTime.getTime()).local().format('D MMMM YYYY, HH:mm')
    }
  }

  get content () {
    if (this.mailInfo?.length) {
      return this.mailInfo[0].content
    }
  }

  setGallery (ind: number) {
    this.$store.commit('setGallery', { index: ind, images: this.fullScreenPictures })
  }

  async updateLeadStatus (status: boolean) {
    const feedback = $newObj(CustomerLeadFeedbackModel)
    feedback.leadId = this.lead.id as string
    feedback.evaluation = status ? LeadFeedbackStatus.Like : LeadFeedbackStatus.Dislike
    await this.$store.dispatch('updateLeadStatus', feedback)
    this.$bvModal.hide('modal-1')
  }
}
